<template>
  <div class="street" :class="{active: active, deselected: deselected}">
    <p>{{ street.name }}</p>
    <select v-model="selected" @click.stop>
      <option value="" disabled selected>{{ $t("streetEntry.num") }}</option>
      <option v-for="nr in houseNumbers" :key="nr.id" :value="nr.hnr">{{ nr.hnr }}</option>
    </select>
  </div>
</template>

<script>
import {basemap} from "@/services/map/basemap";
import M2wApi from "@/services/m2w_api";

export default {
  name: "StreetEntry",
  props: ["street", "active", "deselected"],
  data() {
    return {
      houseNumbers: [],
      activeLine: null,
      activeMarker: null,
      selected: "",
      hnr: null,
    };
  },
  watch: {
    active: async function (val, oldval) {
      if (val != oldval) {
        this.cleanup();
      }
      await this.onActiveFunc();
    },

    selected: function (val) {
      if (val !== "" && this.$route.query.hnr !== val) {
        this.$router.replace({query: {...this.$route.query, hnr: val}});
        this.hnrFromQuery();
      }
    },

    "$route.query.hnr": function () {
      this.hnrFromQuery();
    },
  },

  async mounted() {
    await this.onActiveFunc();
  },
  async activated() {
    await this.onActiveFunc();
  },
  deactivated() {
    this.cleanup();
  },
  destroyed() {
    this.cleanup();
  },

  methods: {
    async onActiveFunc() {
      if (this.activeLine) basemap.map.removeLayer(this.activeLine);
      if (!this.active) return;

      this.activeLine = basemap.drawLine(this.street.geom);
      const extent = this.activeLine.getSource().getExtent();
      basemap.map.getView().fit(extent, { duration: 1000 });

      if (this.houseNumbers.length === 0) {
        this.houseNumbers = (await M2wApi.get_single_street(this.street.id)).house_numbers;
      }

      const g = this.street.geom;
      let geometry;

      if (g?.type === "LineString") {
        geometry = { type: "LineString", coordinates: g.coordinates };
      } else if (g?.type === "MultiLineString") {
        geometry = { type: "MultiLineString", coordinates: g.coordinates };
      } else {
        return;
      }
      const featureStreet = {
      type: "Feature",
      geometry,
      properties: {
        name: this.street.name,
        streetId: this.street.id,
        line_color: "#ff0000",
        width: 4,
        addStartStop: true,
        role: "street",
        }
      };
      this.$root.$emit("poiSelectedFromList", featureStreet);

      this.$el.scrollIntoView({ block: "nearest" });
      this.hnrFromQuery();
    },

    hnrFromQuery() {
      if (this.activeMarker) basemap.map.removeLayer(this.activeMarker);
      if (!this.active) return;

      const hnr = this.$route.query.hnr;
      const num = this.houseNumbers.find((x) => x.hnr === hnr);
      if (!num) return;

      this.hnr = num;
      this.selected = hnr;

      this.activeMarker = basemap.createMarkerForCoordinates(num.geom.coordinates);
      basemap.map.getView().animate({ center: num.geom.coordinates, duration: 200 });

      const to4326 = ([x, y]) => {
        const is3857 = Math.abs(x) > 180 || Math.abs(y) > 90;
        if (!is3857) return [x, y];
        const R = 6378137;
        const lon = (x / R) * 180 / Math.PI;
        const lat = (2 * Math.atan(Math.exp(y / R)) - Math.PI / 2) * 180 / Math.PI;
        return [lon, lat];
      };

      const coords4326 = to4326(num.geom.coordinates);

      const feature = {
        type: "Feature",
        geometry: { type: "Point", coordinates: coords4326 }, // [lng, lat]
        properties: {
          role: "hnr", 
          name: `${this.street.name} ${hnr}`,
          // poți lăsa fără icon și WeatherMTK pune id: "marker",
          // sau setezi o iconiță proprie:
          // icon: "https://…/hnr-pin.png"
        },
      };

      this.$root.$emit("poiSelectedFromList", feature);
    },

    async chooseHnr(num_obj) {
      await this.$router.push({query: {...this.$route.query, hnr: num_obj.hnr}});
    },

    cleanup() {
      this.selected = "";
      this.hnr = null;
      if (this.activeMarker) basemap.map.removeLayer(this.activeMarker);
      if (this.activeLine) basemap.map.removeLayer(this.activeLine);

      this.$router.replace({query: {...this.$route.query, hnr: null}});
    },
  },
};
</script>

<style scoped></style>
